import { fetchFeed } from "./api.js";
import { createDefineUI } from "./define.js";
import { renderArticles, renderErrors } from "./stream.js";
import { formatTodayDate, loadPrefs, renderChips } from "./ui.js";

const statusEl = document.getElementById("stream-status");
const errorsEl = document.getElementById("stream-errors");
const articlesEl = document.getElementById("articles");
const streamEl = document.getElementById("stream");

document.getElementById("today-date").textContent = formatTodayDate();

const prefs = loadPrefs();
const defineUI = createDefineUI(document.getElementById("define-root"));
defineUI.bind(articlesEl);

let loadSeq = 0;

async function loadStream(current) {
  const seq = ++loadSeq;
  streamEl.setAttribute("aria-busy", "true");
  statusEl.hidden = false;
  statusEl.textContent = "Loading today’s stories…";
  articlesEl.replaceChildren();
  renderErrors(errorsEl, []);

  try {
    const data = await fetchFeed({
      langs: current.langs,
      sectors: current.sectors,
    });
    if (seq !== loadSeq) return;

    renderErrors(errorsEl, data.errors || []);
    if (!data.articles?.length) {
      statusEl.textContent = "No stories for these filters right now. Try enabling more languages or sectors.";
      statusEl.hidden = false;
    } else {
      statusEl.hidden = true;
      renderArticles(articlesEl, data.articles);
    }
  } catch (err) {
    if (seq !== loadSeq) return;
    statusEl.hidden = false;
    statusEl.textContent = "Couldn't reach the Rosetta API. Is the Worker running?";
    console.error(err);
  } finally {
    if (seq === loadSeq) streamEl.setAttribute("aria-busy", "false");
  }
}

renderChips(
  document.getElementById("lang-chips"),
  document.getElementById("sector-chips"),
  prefs,
  (next) => loadStream(next),
);

loadStream(prefs);
